/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalAuthIntegrationCredentialsType = {
    OrganizationWide: 'organization_wide',
    FacilitySpecific: 'facility_specific'
} as const;
export type PalAuthIntegrationCredentialsType = typeof PalAuthIntegrationCredentialsType[keyof typeof PalAuthIntegrationCredentialsType];


export function PalAuthIntegrationCredentialsTypeFromJSON(json: any): PalAuthIntegrationCredentialsType {
    return PalAuthIntegrationCredentialsTypeFromJSONTyped(json, false);
}

export function PalAuthIntegrationCredentialsTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthIntegrationCredentialsType {
    return json as PalAuthIntegrationCredentialsType;
}

export function PalAuthIntegrationCredentialsTypeToJSON(value?: PalAuthIntegrationCredentialsType | null): any {
    return value as any;
}

